// src/views/Home.js
/* global gdAlertify */

import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { Grid, _ } from 'gridjs-react';
import { gridOptions } from "../utils/gridOptions";
import axiosInstance from "../config/axiosConfig";
import { formatDate } from "../utils/utils";
import { useNavigate } from 'react-router-dom';
import GdTable from './components/GdTable';

function Home() {
    const navigate = useNavigate();
    const [solicitudes, setSolicitudes] = useState([]);
    const [sectoresActivos, setSectoresActivos] = useState([]);

    useEffect(() => {
        async function fetchData() {
            try {
                // Obtener lista completa de asignaciones para buscar los activos
                const planifResp = await axiosInstance.get("/planificacion/lista");
                if (planifResp.data && planifResp.data.data) {
                    const activos = planifResp.data.data.filter(p => !p.fecha_fin); // Asumiendo active si fecha_fin es null
                    setSectoresActivos(activos);
                }

                // Obtener solicitudes
                const solicitudes = await axiosInstance.post("/reemplazos/solicitud/lista",
                    { pendientes: true }
                );
                if (solicitudes.data.error) {
                    setSolicitudes([]);
                } else {
                    setSolicitudes(solicitudes.data.data);
                }
            } catch (error) {
                console.error("Error al obtener los datos: ", error);
            }
        }

        fetchData();
    }, []);

    const eliminar = (id) => {
        gdAlertify.confirm({
            title: 'Eliminar Solicitud de reemplazo',
            message: '¿Está seguro de que desea eliminar esta Solicitud de reemplazo?',
            onConfirm: async () => {
                try {
                    const response = await axiosInstance.post('/reemplazos/solicitud/eliminar', { id: id });

                    if (!response.data.error) {
                        gdAlertify.notify('Solicitud de reemplazo eliminada correctamente', 'success');
                        setTimeout(() => {
                            window.location.reload();
                        }, 1000);
                    } else {
                        gdAlertify.notify(response.data.message || 'Error al eliminar la Solicitud de reemplazo', 'error');
                    }
                } catch (error) {
                    gdAlertify.notify('Error al eliminar la Solicitud de reemplazo', 'error');
                }
            },
            onCancel: () => {
                gdAlertify.notify('Acción cancelada', 'info');
            }
        });
    };

    const columns = [
        { name: 'id', title: 'Solicitud' },
        { name: 'nombrePaciente', title: 'Paciente' },
        { name: 'nombreAuxiliar', title: 'Auxiliar' },
        { name: 'fechaCrea', title: 'Fecha Creación', render: (row) => formatDate(row.fechaCrea) },
        { name: 'fechaInicio', title: 'Fecha Inicio', render: (row) => formatDate(row.fechaInicio) },
        { name: 'fechaFin', title: 'Fecha Fin', render: (row) => formatDate(row.fechaFin) },
        { name: 'desTurno', title: 'Turno' },
        {
            name: 'estado',
            title: 'Estado',
            render: (row) => (
                row.estado == 1 ? 'Terminada' : 'Pendiente'
            )
        },
        {
            name: 'id',
            title: 'Acción',
            render: (row) =>
            (
                row.estado === 1 ? null : (
                    <div className='d-flex'>
                        <button
                            className="btn btn-primary"
                            onClick={() => navigate('/new-ingreso-reemplazos/' + row.id)}
                        >
                            Resolver
                        </button>
                        <button
                            className="btn btn-danger"
                            onClick={() => eliminar(row.id)}
                        >
                            Eliminar
                        </button>
                    </div>
                )
            ),
        }
    ]


    return (
        <div className='row p-1'>
            <div className='col-md-8 mt-4 mb-4 mx-auto'>
                {/* Sectores / Procedimientos Activos (Widget) */}
                <div className="card mb-4 shadow-sm border-0">
                    <div className="card-header bg-primary text-white">
                        <h5 className="mb-0"><i className="bi bi-geo-alt-fill me-2"></i>Sectores / Procedimientos Asignados Actuales</h5>
                    </div>
                    <div className="list-group list-group-flush">
                        {sectoresActivos.length > 0 ? (
                            sectoresActivos.map((sector) => (
                                <div key={sector.id} className="list-group-item d-flex justify-content-between align-items-center">
                                    <div>
                                        <span className="fw-bold">{sector.nombre_sector}</span>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <div className="bg-light rounded-pill px-3 py-1 border d-flex align-items-center">
                                            <i className="bi bi-person-fill text-secondary me-2"></i>
                                            <span className="fw-medium text-dark">
                                                {sector.nombre_usuario || "Sin Asignar"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="list-group-item text-muted text-center py-3">
                                <em>No hay sectores o procedimientos asignados actualmente.</em>
                            </div>
                        )}
                    </div>
                </div>

                {/* Tabla de resultados */}
                {/* <div className="card card-body mt-4"> */}
                <h5>Solicitudes de reemplazo pendientes</h5>
                {/* </div> */}
                {/* <Grid
                    data={solicitudes}
                    columns={[
                        { id: 'id', name: 'Solicitud' },
                        { id: 'nombrePaciente', name: 'Paciente' },
                        { id: 'nombreAuxiliar', name: 'Auxiliar' },
                        { id: 'fechaCrea', name: 'Fecha Creación', formatter: (cell) => formatDate(cell) },
                        { id: 'fechaInicio', name: 'Fecha Inicio', formatter: (cell) => formatDate(cell) },
                        { id: 'fechaFin', name: 'Fecha Fin', formatter: (cell) => formatDate(cell) },
                        { id: 'desTurno', name: 'Turno' },
                        {
                            id: 'estado',
                            name: 'Estado',
                            formatter: (value, row) => (
                                value == 1 ? 'Terminada' : 'Pendiente'
                            )
                        },
                        {
                            id: 'id',
                            name: 'Acción',
                            formatter: (value, row, cell) =>
                                _(
                                    row._cells[7].data === 1 ? null : (
                                        <button
                                            className="btn btn-primary"
                                            onClick={() => navigate('/ingreso-reemplazos/' + value)} // Captura el ID
                                        >
                                            Resolver
                                        </button>
                                    )
                                ),
                        }
                    ]}
                    language={gridOptions.language}
                    search={false}
                    sort={true}
                    pagination={gridOptions.pagination}
                /> */}
                <div className="mt-3">
                    <div className="card">
                        <div className="card-body">
                            {/* Tabla de solicitudes */}
                            <GdTable
                                columns={columns}
                                data={solicitudes}
                                defaultItemsPerPage={100}
                                itemsPerPageOptions={[5, 10, 25, 50, 100]}
                                initialSort={[4, "asc"]}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;
